<template>
    <div v-if="data && data.image" :class="{ portrait: data.image.height > data.image.width }">
        <CopyrightedImage v-if="data" :image="data.image" :caption="data.caption" />
    </div>
</template>

<script setup lang="ts">
import type { RelationNodeProps } from "directus-extension-flexible-editor/content";

defineProps<{
    id: RelationNodeProps["id"];
    junction: RelationNodeProps["junction"];
    collection: RelationNodeProps["collection"];
    data?: RelationNodeProps["data"];
}>();
</script>

<style lang="scss" scoped>
.portrait {
    max-width: var(--text-maxwidth-body);
    position: relative;
}
</style>